export const PROMO_RESET_TIMEOUT = 3000;
export const COPY_ERROR_MESSAGE = 'Failed to copy coupon code:';
